import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../components/constants';

// Async thunk for fetching user data
export const fetchUserData = createAsyncThunk(
  'userData/fetchUserData',
  async (email) => {
    const formData = new FormData();
    formData.append('email', email);
    const response = await axios.post( `${BASE_URL}/get-user`, formData);
    return response.data;
  }
);

const userDataSlice = createSlice({
  name: 'userData',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearUserData: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearUserData } = userDataSlice.actions;
export default userDataSlice.reducer;
